import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { Component, EventEmitter, forwardRef, Input } from '@angular/core';

import { NgbDatepickerConfig, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';

import { IInputCalendar } from './input.calendar.interface';
import { IInput } from '../../molecules/input/input.interface';
import { IErrors } from './../../molecules/input/errors.interface';

export const INPUT_CUSTOM_INPUT_ACCESSOR: any = {
    provide: NG_VALUE_ACCESSOR,
    // tslint:disable-next-line:no-forward-ref
    useExisting: forwardRef(() => InputCalendarSharedComponent),
    multi: true
};

@Component({
    selector: 'mlp-ng-input-calendar',
    templateUrl: './input.calendar.component.html',
    styleUrls: ['./input.calendar.component.scss'],
    providers: [
        INPUT_CUSTOM_INPUT_ACCESSOR
    ]
})

export class InputCalendarSharedComponent {
    @Input() input: IInputCalendar;
    @Input() inputId: IInputCalendar['inputId'];
    @Input() inputDisabled: IInputCalendar['inputDisabled'];
    @Input() errors: Array<IErrors> = [];
    @Input() ngDatepickerConfig: NgbDatepickerConfig;
    // tslint:disable-next-line:no-input-rename
    @Input('value') _value = '';
    toggleDtp = new EventEmitter();

    dateVal = '';

    get inputSettings(): IInput {
        const input = { ...this.input };

        return input;
    }

    onChange: any = () => {};
    onTouched: any = () => {};

    get id(): any { return (this.input.id) ? this.input.id : ''; }

    get value(): any { return this._value; }
    set value(val) {
        this._value = val;
        this.dateVal = (val) ? this.createDate(val) : '';
        this.onChange(val);
        this.onTouched();
    }

    registerOnChange(fn): void {
        this.onChange = fn;
    }

    writeValue(value: NgbDateStruct): void {
        this.dateVal = (value) ? this.createDate(value) : '';
        this.value = value;
    }

    registerOnTouched(fn): void {
        this.onTouched = fn;
    }

    updateValue(event: NgbDateStruct): void {
        this.value = event;
    }

    createDate(data): string {
        const date = {
            day: this.prependZero(data.day),
            month: this.prependZero(data.month)
        };

        return `${date.day}-${date.month}-${data.year}`;
    }

    prependZero(val): string {
        return `0${val}`.slice(-2);
    }

    updateDate(): void {
        const reg = new RegExp(/^\d{2}-\d{2}-\d{4}$|^\d{1}-\d{1}-\d{4}$|^\d{2}-\d{1}-\d{4}$|^\d{1}-\d{2}-\d{4}$/);
        const MATCHES = reg.test(this.dateVal);

        if (MATCHES) {
            const DATE = this.dateVal.split('-');
            this.updateValue(
                {
                    day: parseInt(this.prependZero(DATE[0]), 10),
                    month: parseInt(this.prependZero(DATE[1]), 10),
                    year: parseInt(DATE[2], 10)
                }
            );
        }
    }

    toggleDatepicker(): void {
        this.toggleDtp.emit();
    }
}
